<div class="showcase-container">
  <div class="header">
    <h1>🎭 Popup Message Showcase</h1>
    <p class="subtitle">Comprehensive view of all {{ totalPopups }} popup messages in the application</p>
    <div class="stats">
      <div class="stat-card">
        <span class="stat-number">{{ totalPopups }}</span>
        <span class="stat-label">Total Popups</span>
      </div>
      <div class="stat-card">
        <span class="stat-number">{{ popupCategories.length }}</span>
        <span class="stat-label">Categories</span>
      </div>
      <div class="stat-card success">
        <span class="stat-number">3</span>
        <span class="stat-label">Standardized Messages</span>
      </div>
    </div>
  </div>

  <div class="alert-box success">
    <div class="alert-icon">✅</div>
    <div class="alert-content">
      <h3>All Messages Standardized!</h3>
      <p>Client issue resolved: Previously there were <strong>6 different retry error messages</strong> for the same scenario. Now we have <strong>3 centralized, consistent messages</strong>:</p>
      <ul>
        <li><strong>showRetryError()</strong> - "Unable to complete your request after 3 attempts. Your chat session is still active - please try again."</li>
        <li><strong>showConnectionIssue()</strong> - Same standardized message for connection problems</li>
        <li><strong>showUnexpectedError()</strong> - "An unexpected error occurred. Please try again." (replaces "Something went wrong")</li>
      </ul>
      <p><strong>✅ All 4 improvements completed:</strong></p>
      <ol>
        <li>✅ Standardized retry error messages</li>
        <li>✅ Created MessageService - all popups centralized</li>
        <li>✅ Unified generic errors to "An unexpected error occurred"</li>
        <li>✅ Removed duplicate delete code in sidebar.component.ts</li>
      </ol>
    </div>
  </div>

  <div class="category-grid">
    <div class="category-card" *ngFor="let category of popupCategories">
      <div class="category-header">
        <div class="category-title">
          <span class="category-icon">{{ category.icon }}</span>
          <h2>{{ category.category }}</h2>
        </div>
        <div class="category-count">
          <span class="count-badge">{{ category.count }}</span>
          <button 
            class="btn-secondary btn-sm"
            (click)="triggerAllInCategory(category)"
            title="Show all popups in this category">
            Show All
          </button>
        </div>
      </div>
      
      <div class="examples-list">
        <div class="example-item" *ngFor="let example of category.examples">
          <div class="example-info">
            <h4>{{ example.title }}</h4>
            <p class="description">{{ example.description }}</p>
            <span class="location">📍 {{ example.location }}</span>
          </div>
          <button 
            class="btn-primary"
            (click)="triggerPopup(example)">
            Show Popup
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="recommendations">
    <h2>🎯 Recommendations for Consistency</h2>
    <div class="recommendation-list">
      <div class="recommendation-item">
        <span class="rec-number">1</span>
        <div class="rec-content">
          <h4>Standardize Retry Error Messages</h4>
          <p>Use a single, consistent message format for all retry failures across all AI services (Gemini, Azure, XAI).</p>
          <div class="code-suggestion">
            <strong>Suggested Message:</strong><br>
            <code>"Unable to complete your request after 3 attempts. Your chat session is still active - please try again."</code>
          </div>
        </div>
      </div>
      
      <div class="recommendation-item">
        <span class="rec-number">2</span>
        <div class="rec-content">
          <h4>Create a Centralized Message Service</h4>
          <p>Move all popup messages to a dedicated service/constant file to ensure consistency and make updates easier.</p>
        </div>
      </div>
      
      <div class="recommendation-item">
        <span class="rec-number">3</span>
        <div class="rec-content">
          <h4>Unify Generic Error Messages</h4>
          <p>Decide between "Something went wrong" vs "An unexpected error occurred" and use consistently.</p>
        </div>
      </div>
      
      <div class="recommendation-item">
        <span class="rec-number">4</span>
        <div class="rec-content">
          <h4>Remove Duplicate Code</h4>
          <p>Session delete confirmation appears in 2 places in sidebar.component.ts (line 304 and 434). Keep only one implementation.</p>
        </div>
      </div>
    </div>
  </div>

  <div class="footer-note">
    <p><strong>Note:</strong> This showcase page is for development/testing purposes only. Click any "Show Popup" button to see the actual popup as users would see it. Use this to review and standardize messaging across the application.</p>
  </div>
</div>
